<script setup>
import AppPlaceholder from '@/components/UI/AppPlaceholder/AppPlaceholder.vue'
import mtCard from '@/components/UI/mtCard/index.vue'
</script>

<template>
  <mtCard class="test-card test-card--skeleton">
    <template #header>
      <div class="test-card--skeleton__header">
        <app-placeholder width="25px" height="25px" border-radius="100%" />
        <app-placeholder
          width="100px"
          height="25px"
          border-radius="20px"
          margin-left="10px"
        />
      </div>
    </template>
    <template #content>
      <div class="test-card--skeleton__content">
        <app-placeholder width="100px" />
        <app-placeholder width="150px" margin-top="10px"/>
      </div>
      <div class="test-card--skeleton__info">
        <app-placeholder width="90%" />
        <app-placeholder width="80%" margin-top="10px"/>
      </div>
      <div class="test-card__footer">
        <app-placeholder height="36px"/>
      </div>
    </template>
  </mtCard>
</template>

<style lang="scss">
.test-card--skeleton {
  max-width: unset!important;
  &__header {
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  &__info {
    margin-top: auto;
    margin: 40px 0; 
  }

  &__content {
    padding: 0;
    width: 100%;
  }
}
</style>
